// TODO this and GA4 could be combined together and become a hook

declare global {
    interface Window {
        dataLayer: any;
    }
}

interface ICartEventParams {
    name?: string;
    id: string;
    price?: number;
    category?: string;
    currency?: string;
    qty: number;
}

const isBrowser = typeof window !== 'undefined';
if (isBrowser) window.dataLayer = window.dataLayer || [];

export function pushAddToCartEvent(addToCartParams: ICartEventParams): void {
    const { id, name, category, price, currency, qty } = addToCartParams;

    if (isBrowser) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: 'addToCart',
            ecommerce: {
                add: {
                    products: [
                        {
                            id: id,
                            name: name,
                            category: category,
                            price: price,
                            currencyCode: currency,
                            quantity: qty,
                        },
                    ],
                },
            },
        });
    }
}

export function pushRemoveFromCartEvent(
    addToCartParams: ICartEventParams
): void {
    const { id, price, currency, qty } = addToCartParams;

    if (isBrowser) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: 'removeFromCart',
            ecommerce: {
                remove: {
                    products: [
                        {
                            id: id,
                            price: price,
                            currencyCode: currency,
                            quantity: qty,
                        },
                    ],
                },
            },
        });
    }
}

interface IProductViewEventParams {
    name: string;
    id: string;
    price: number;
    currency?: string;
    category: string;
}
export function pushProductImpressionEvent(
    productImpressionParams: IProductViewEventParams
): void {
    const { name, id, price, currency, category } = productImpressionParams;

    if (isBrowser) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            ecommerce: {
                impressions: [
                    {
                        name: name,
                        id: id,
                        price: price,
                        currencyCode: currency,
                        category: category,
                    },
                ],
            },
        });
    }
}

export function pushProductViewEvent(
    productImpressionParams: IProductViewEventParams
): void {
    const { name, id, price, currency, category } = productImpressionParams;

    if (isBrowser) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            ecommerce: {
                detail: {
                    products: [
                        {
                            name: name,
                            id: id,
                            price: price,
                            currencyCode: currency,
                            category: category,
                        },
                    ],
                },
            },
        });
    }
}

const gaCartItems = (items: any) => {
    return items.map((item: any) => {
        return {
            name: item.product.name,
            id: item.product.sku,
            price: item.prices.price.value,
            currencyCode: item.prices.price.currency,
            quantity: item.quantity,
        };
    });
};

export function pushBeginCheckout(items: any): void {
    if (isBrowser) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: 'checkout',
            ecommerce: {
                checkout: {
                    actionField: {
                        step: 1,
                    },
                    products: gaCartItems(items),
                },
                currencyCode: items[0].prices.price.currency,
            },
        });
    }
}

export function pushPurchaseEvent(pushPurchaseParams: any): void {
    const { transaction_id, value, tax, shipping, items } = pushPurchaseParams;

    if (isBrowser) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: 'purchase',
            ecommerce: {
                purchase: {
                    actionField: {
                        id: transaction_id,
                        revenue: value,
                        tax: tax,
                        shipping: shipping,
                    },
                    products: gaCartItems(items),
                },
                currencyCode: items[0].prices.price.currency,
            },
        });
    }
}
